function AnimateValue(obj, start, end, duration) {

    jQuery(function() {

        let counted = 0;
        jQuery(window).scroll(function() {
        if(jQuery('.number-spinner-wrapper').length > 0){
            let oTop = jQuery('.number-spinner-wrapper').offset().top - window.innerHeight;
            if (counted == 0 && jQuery(window).scrollTop() > oTop) {
                jQuery('.number__spinner').each(function() {
                var $this = jQuery(this),
                    countTo = $this.attr('data-target');
                jQuery({
                    countNum: $this.text()
                }).animate({
                    countNum: countTo
                    },
    
                    {
    
                    duration: Number($this.attr('data-time'))*1000,
                    easing: 'swing',
                    step: function() {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function() {
                        $this.text(this.countNum);
                        //alert('finished');
                    }
    
                    });
                });
                counted = 1;
            }
        }
       

        });



        
      });


}
    
  
 export default AnimateValue;